import React, { FC } from "react";
import { IMatricula } from "@deltasge/marauders-map";
import {
  Box,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Avatar } from "components/Avatar";

export const AnaliseIndividual: FC<{
  titulo: string;
  matriculas: IMatricula[];
  textos: Record<number, string>;
  loading: boolean;
  saving: boolean;
  onChange: (idAluno: number, texto: string) => void;
  onSave: () => void;
}> = ({ titulo, matriculas, textos, loading, saving, onChange, onSave }) => {
  return (
    <Box sx={{ pb: 6 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" color="primary">
          Análise dos Casos Individuais
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {titulo}
        </Typography>
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        gutterBottom
        sx={{ mb: 3 }}
      >
        Segundo Momento: Preencha o parecer apenas para aqueles alunos que
        preocupam ou que necessitam de apontamentos específicos.
      </Typography>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {!loading &&
        matriculas.map((matricula) => {
          const idAluno = matricula.aluno?.uid;
          if (idAluno == undefined) return null;
          const nome =
            matricula.aluno?.nomeusual || matricula.aluno?.nome || "";
          return (
            <Box
              key={`acompanhamento_aluno_${idAluno}`}
              sx={{
                mb: 2,
                p: 2,
                border: "1px solid #e0e0e0",
                bgcolor: "#fff",
              }}
            >
              <Grid container alignItems="flex-start" spacing={2}>
                <Grid item>
                  <Avatar
                    displayName={nome.rUpper()}
                    src={
                      matricula.aluno?.imagemAluno?.caminhoArquivo ?? undefined
                    }
                    sx={{ width: 36, height: 36 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="body1" fontWeight="500">
                    {matricula.nrChamada != undefined
                      ? `${matricula.nrChamada} - ${nome}`
                      : nome}
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    minRows={2}
                    size="small"
                    variant="outlined"
                    placeholder={`Parecer pedagógico para ${nome}...`}
                    value={textos[idAluno] ?? ""}
                    onChange={(event) => onChange(idAluno, event.target.value)}
                    sx={{
                      mt: 1,
                      "& .MuiOutlinedInput-root": { bgcolor: "#fafafa" },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          );
        })}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={onSave}
          loading={saving}
        >
          Salvar
        </LoadingButton>
      </Box>
    </Box>
  );
};
